exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pricing{text-align:center;padding:30px 0 0}.pricing .pricing__image{text-align:center;max-width:800px;padding:25px 0 20px}.pricing .pricing__btn{font-size:18px;color:#9d9c9a;font-weight:700;line-height:1}.pricing .pricing__btn:hover{text-decoration:none}.pricing .pricing__btn strong{border-bottom:2px solid #9d9c9a;position:relative;top:-5px}.pricing .pricing__btn span{text-decoration:none;display:inline-block;width:34px;height:34px;border-radius:50%;border:2px solid #9d9c9a;line-height:28px;text-align:center;font-weight:700;color:#9d9c9a;font-size:24px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/CruiseOverview.vue
// module id = 400
// module chunks = 0